import { useState, useEffect } from "react";
import { Box, Skeleton, useToast } from "@chakra-ui/react";
import { Line } from "react-chartjs-2";
import useAxios from "../../utils/useAxios";

interface Props {
  deviceId: number;
  isGraphloading: boolean;
  setIsGraphloading: (isLoading: boolean) => void;
}

const MiniRainGraph = ({ deviceId, isGraphloading, setIsGraphloading }: Props) => {
  const api = useAxios();
  const toast = useToast();
  const [timestamps, setTimestamps] = useState<string[]>([]);
  const [values, setValues] = useState<Array<number | null>>([]);

  useEffect(() => {
    setIsGraphloading(true);
    const fetchData = async () => {
      if (!deviceId) return;
      try {
        const response = await api.get(`agtech/weather-station/data/${deviceId}/`, {
          params: {
            last_number_of_days: 5,
            interval: "daily",
          },
        });
        const series = response.data.series;
        if (series && series.length) {
          setTimestamps(
            series.map((item: any) => {
              const d = new Date(item.timestamp);
              const day = String(d.getDate()).padStart(2, "0");
              const month = String(d.getMonth() + 1).padStart(2, "0");
              return `${day}.${month}`;
            })
          );
          setValues(series.map((item: any) => item.precipitation));
        }
      } catch (err) {
        console.error(err);
        toast({
          title: "Error",
          description: "Failed to fetch weather station data",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setIsGraphloading(false);
      }
    };
    fetchData();
  }, [deviceId]);

  if (isGraphloading) {
    return <Skeleton />;
  }

  return (
    <Box>
      <Line
        data={{
          labels: timestamps,
          datasets: [
            {
              label: "Precipitation (mm)",
              data: values,
              fill: true,
              backgroundColor: "rgba(7, 7, 255, 0.7)",
              borderColor: "rgba(7, 7, 255, 1)",
              type: "bar",
            },
          ],
        }}
        options={{
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 10,
                },
              },
            ],
          },
        }}
      />
    </Box>
  );
};

export default MiniRainGraph;
